import React, { useCallback, useEffect, useState } from "react";
import {
  Container,
  Box,
  Typography,
  Button,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  Card,
  CardContent,
  CardActions,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  Switch,
  FormControlLabel,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import {
  ViewList as ViewListIcon,
  ViewModule as ViewModuleIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  School as SchoolIcon,
  Facebook as FacebookIcon, // Cho Fanpage
  Groups as GroupsIcon, // Cho Nhóm
  Search as SearchIcon,
  MenuBook as MenuBookIcon,
  QuestionAnswer as QuestionAnswerIcon
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
// import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AiFormDialog from "./AiFormDialog";
import ApplyFanpageDialog from "./ApplyFanpageDialog";
import api from "../../../../Apis";
import { useCookies } from "react-cookie";
import { formatDateToHMYMD, getDayName } from "../../../../Helpers/function";

export default function Ai() {
  const navigate = useNavigate();
  const [cookies] = useCookies("is_login");
  const [viewMode, setViewMode] = useState("list");
  const [aiList, setAiList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [openAiDialog, setOpenAiDialog] = useState(false);
  const [selectedAi, setSelectedAi] = useState(null);

  const [openApplyPage, setOpenApplyPage] = useState(false);
  const [openApplyGroup, setOpenApplyGroup] = useState(false);
  const [applyingAi, setApplyingAi] = useState(null);
  const [state, setState] = useState({
    selected_group_fanpage: [],
    list_group_fanpage: [],
    list_fanpages: [],
    fanpage_selected: []
  })

  const loadAis = useCallback(async () => {
    try {
      setIsLoading(true);
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookies.is_login}`,
        },
      };
      const res = await fetch(api.ai_management, requestOptions);
      const data = await res.json();
      if (data.success) {
        setAiList(data?.data || []);
      } else {
        throw new Error(data?.message || "Failed to fetch AI list");
      }
    } catch (error) {
      console.log("Error fetching AI list:", error);
    }finally {
      setIsLoading(false);
    }
}, [cookies.is_login]);

  // Xử lý bật tắt Switch
  const handleToggleStatus = async(ai) => {
    // setAiList((prev) =>
    //   prev.map((ai) => (ai.id === id ? { ...ai, active: !ai.active } : ai))
    // );
    try {
      setIsLoading(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookies.is_login}`,
        },
        body: JSON.stringify({ ai_bot_id: ai.id, is_active: ai.is_active ? 0 : 1 }),
      };
      const res = await fetch(`${api.ai_management}/active`, requestOptions);  
      const data = await res.json();
      if (data.success) {
        setAiList((prev) =>
          prev.map((item) =>
            item.id === ai.id ? { ...item, is_active: !item.is_active } : item
          )
        );
      } else {
        throw new Error(data?.message || "Failed to toggle AI status");
      }
    } catch (error) {
      Swal.fire("Cập nhật trạng thái thất bại", "", "error");
      console.log("Error toggling AI status:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleDelete = (id) => {
    Swal.fire({
      title: "Bạn có chắc chắn?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Xóa ngay",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        try {
          const requestOptions = {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${cookies.is_login}`,
            },
          };
          const res = await fetch(
            `${api.ai_management}?ai_bot_id=${id}`,
            requestOptions
          );
          const data = await res.json();
          if (data.success) {
            setAiList(aiList.filter((item) => item.id !== id));
            Swal.fire("Đã xóa!", "", "success");
          } else {
            throw new Error(data?.message || "Failed to delete AI");
          }
        } catch (error) {
          Swal.fire("Xoá thất bại", "", "error");
          console.log("Error deleting AI:", error);
        } finally {
          setIsLoading(false);
        }
      }
    });
  };

  const handleCreateAI = async (values) => {
    try {
      setIsLoading(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookies.is_login}`,
        },
        body: JSON.stringify(values),
      };
      const res = await fetch(api.ai_management, requestOptions);
      const data = await res.json();
      if (data.success) {
        loadAis();
        Swal.fire("Tạo AI thành công!", "", "success");
      } else {
        throw new Error(data?.message || "Failed to create AI");
      }
    } catch (error) {
      Swal.fire("Tạo AI thất bại", "", "error");
      console.log("Error creating AI:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateAI = async (values) => {    
    if (!selectedAi) return;

    try {
      setIsLoading(true);
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookies.is_login}`,
        },
        body: JSON.stringify({ ...values, ai_bot_id: selectedAi.id, is_active: selectedAi.is_active }),
      };
      const res = await fetch(api.ai_management, requestOptions);
      const data = await res.json();
      if (data.success) {
        loadAis();
        Swal.fire("Cập nhật AI thành công!", "", "success");
        // setAiList((prev) =>
        //   prev.map((ai) =>
        //     ai.id === selectedAi.id ? { ...ai, ...data?.data } : ai
        //   )
        // );
      } else {
        throw new Error(data?.message || "Failed to update AI");
      }
    } catch (error) {
      Swal.fire("Cập nhật AI thất bại", "", "error");
      console.log("Error updating AI:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeFanpage = useCallback((fanpage_selected) => {
    setState((prevState) => ({
      ...prevState,
      fanpage_selected: fanpage_selected,
    }));
  }, []);

  const handleSelectGroupFanpageChange = useCallback((value) => {          
    setState((prevState) => ({
      ...prevState,
      selected_group_fanpage: value,
    }));
  },[])

  const navigateToAITraining = ({
    ai_id,
    ai_name
  }) => {
    navigate(`/dashboard/ai/chat/${ai_id}`, {
      state: {
        ai_name,  
      }
    })
  }

  useEffect(() => {
    loadAis();
  }, [cookies.is_login, loadAis]);

  useEffect(() => {
    const loadFanpages = async () => {
      try {
        const res = await fetch(api.get_fanpage, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookies.is_login}`,
          },
        });
        const data = await res.json();
        setState((prevState) => ({
          ...prevState,
          list_fanpages: data.datas.fanpage_actives,
        }));
      } catch (error) {
        console.error("Load fanpages error:", error);
      }
    };
    const loadGroupFanpages = async () => {
      try {
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.is_login}` },
        };

        const res = await fetch(api.group_fanpage, requestOptions)
        const data = await res.json();
        if(data?.success){
          setState((prevState) => ({
            ...prevState,
            list_group_fanpage: data?.data || []
          }));
        }        
      }catch (error) {
        console.error("Load group fanpages error:", error);
      }
    }

    loadFanpages();
    loadGroupFanpages();
  }, [cookies.is_login]);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 101 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Typography variant="h5" fontWeight="bold">
          Danh sách Bot AI
        </Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          {/* FIX: Thay unique bằng exclusive để hoạt động */}
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(e, next) => next && setViewMode(next)}
            size="small"
          >
            <ToggleButton value="list">
              <ViewListIcon />
            </ToggleButton>
            <ToggleButton value="grid">
              <ViewModuleIcon />
            </ToggleButton>
          </ToggleButtonGroup>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              setSelectedAi(null);
              setOpenAiDialog(true);
            }}
            className="text-transform"
          >
            Thêm mới
          </Button>
        </Box>
      </Box>

      {viewMode === "list" ? (
        <TableContainer component={Paper} elevation={2}>
          <Table>
            <TableHead sx={{ bgcolor: "#f5f5f5" }}>
              <TableRow>
                <TableCell>Bật/tắt trả lời</TableCell>
                <TableCell>Bot AI</TableCell>
                <TableCell>Khung giờ</TableCell>
                <TableCell>Ngày tạo</TableCell>
                <TableCell align="center">Thao tác</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {aiList.map((ai) => (
                <TableRow key={ai.id}>
                  <TableCell>
                    <Switch
                      checked={ai.is_active}
                      onChange={() => handleToggleStatus(ai)}
                      color="primary"
                    />
                  </TableCell>
                  <TableCell sx={{ fontWeight: "medium" }}>
                    <Tooltip title="Huấn luyện Bot AI" placement="top" arrow>
                      <Typography
                        variant="inherit"
                        sx={{ 
                          cursor: "pointer", 
                          textDecoration: "underline", 
                          display: "inline-block"
                        }}
                        onClick={() => navigateToAITraining({ ai_id: ai.id, ai_name: ai.name })}
                        color="primary"
                      >
                        {ai.name}
                      </Typography>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    {ai.time_type === 1 ? (
                      <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                        {ai.setting_times && ai.setting_times.length > 0 ? (
                          ai.setting_times.map((schedule, index) => (
                            <Typography key={index} variant="body2">
                              {getDayName(schedule.week_day)} : <b>{schedule.hour_start}</b> {"->"} <b>{schedule.hour_end}</b>
                            </Typography>
                          ))
                        ) : (
                          <Typography variant="caption" color="error">Chưa cài đặt</Typography>
                        )}
                      </div>
                    ) : (
                      <Typography variant="body2">Luôn trả lời</Typography>
                    )}
                  </TableCell>
                  <TableCell>{formatDateToHMYMD(ai.created_at)}</TableCell>
                  <TableCell>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <ActionButtons
                        ai={ai}
                        onEdit={() => {
                          setSelectedAi(ai);
                          setOpenAiDialog(true);
                        }}
                        onDelete={() => handleDelete(ai.id)}
                        onApplyPage={() => {
                          setApplyingAi(ai);
                          setOpenApplyPage(true);
                        }}
                        onApplyGroup={() => {
                          setApplyingAi(ai);
                          setOpenApplyGroup(true);
                        }}
                        onTrain={() =>
                          navigateToAITraining({ai_id: ai.id, ai_name: ai.name})
                        }
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Grid container spacing={3}>
          {aiList.map((ai) => (
            <Grid item xs={12} sm={6} md={4} key={ai.id}>
              <Card elevation={3}>
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <Tooltip title="Huấn luyện Bot AI" placement="top" arrow>
                      <Typography
                        variant="h6"
                        gutterBottom
                        noWrap
                        sx={{ maxWidth: "70%", cursor: "pointer", textDecorationLine: "underline", display: "inline-block" }}
                        onClick={() => navigateToAITraining({ai_id: ai.id, ai_name: ai.name})}
                        color="primary"
                      >
                        {ai.name}
                      </Typography>
                    </Tooltip>
                    <Switch
                      checked={ai.is_active}
                      onChange={() => handleToggleStatus(ai)}
                      size="small"
                    />
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    Khung giờ: {ai.time_type === 1 ? "Tuỳ chỉnh" : "Luôn trả lời"}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Ngày tạo: {formatDateToHMYMD(ai.created_at)}
                  </Typography>
                </CardContent>
                <CardActions
                  sx={{
                    justifyContent: "flex-end",
                    borderTop: "1px solid #eee",
                  }}
                >
                  <ActionButtons
                    ai={ai}
                    onEdit={() => {
                      setSelectedAi(ai);
                      setOpenAiDialog(true);
                    }}
                    onDelete={() => handleDelete(ai.id)}
                    onApplyPage={() => {
                      setApplyingAi(ai);
                      setOpenApplyPage(true);
                    }}
                    onApplyGroup={() => {
                      setApplyingAi(ai);
                      setOpenApplyGroup(true);
                    }}
                    onTrain={() => navigateToAITraining({ai_id: ai.id, ai_name: ai.name})}
                  />
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Dialog Components */}
      <AiFormDialog
        open={openAiDialog}
        handleClose={() => setOpenAiDialog(false)}
        initialData={selectedAi}
        onSubmit={(data) => {
          if (selectedAi) {
            handleUpdateAI(data);
          } else {
            handleCreateAI(data);
          }
          setOpenAiDialog(false);
        }}
        state={state}
        handleChangeFanpage={handleChangeFanpage}
        handleSelectGroupFanpageChange={handleSelectGroupFanpageChange}
      />

      <ApplyFanpageDialog
        open={openApplyPage}
        handleClose={() => setOpenApplyPage(false)}
        aiData={applyingAi}
      />

      {/* Bạn có thể dùng chung ApplyFanpageDialog nhưng truyền props khác đi để xử lý Nhóm */}
      <ApplyFanpageDialog
        open={openApplyGroup}
        handleClose={() => setOpenApplyGroup(false)}
        aiData={applyingAi}
        isGroupMode={true} // Thêm prop này để phân biệt trong Dialog
      />
    </Container>
  );
}

function ActionButtons({
  ai,
  onEdit,
  onDelete,
  onApplyPage,
  onApplyGroup,
  onTrain,
}) {
  return (
    <Box sx={{ display: "flex", gap: 0.5 }}>
      <Tooltip placement="top" arrow title="Test Bot AI">
        <IconButton color="primary" onClick={onTrain} size="small">
          <QuestionAnswerIcon />
        </IconButton>
      </Tooltip>
      {/* <Tooltip placement="top" arrow title="Áp dụng Fanpage">
        <IconButton color="info" onClick={onApplyPage} size="small">
          <FacebookIcon />
        </IconButton>
      </Tooltip>
      <Tooltip placement="top" arrow title="Áp dụng Nhóm Page">
        <IconButton color="secondary" onClick={onApplyGroup} size="small">
          <AccountTreeIcon />
        </IconButton>
      </Tooltip> */}
      <Tooltip placement="top" arrow title="Sửa tên">
        <IconButton onClick={onEdit} size="small">
          <EditIcon />
        </IconButton>
      </Tooltip>
      <Tooltip placement="top" arrow title="Xóa AI">
        <IconButton color="error" onClick={onDelete} size="small">
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
